import { Box, Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
// import ModalLevel from "../../modal/camiones/modalPermisos";
import ModalCliente from "../../modal/cliente/modalCliente";
import { PostDatos } from "../../services/cliente.services";
import { PostDatosEstante } from "../../services/estante.services";
  import { toast } from "react-toastify";
import ModalCharge from "../../modal/modalCharge";
import ModalEstante from "../../modal/estante/modalEstante";
import { es } from "date-fns/locale";
import { PostDatosFila } from "../../services/fila.services";
import { PostDatosColumna } from "../../services/columna.services";
import ModalDepositoAmoxarifado from "../../modal/amoxarifado/modalDeposito";
import ModalEstanteGetOne from "../../modal/estante/modalEstantegetOne";
import ModalFilaGetOne from "../../modal/fila/modalFilaOneMul";


const Columna = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalClienteOpen, setIsModalClienteOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [selected, setSelected] = useState({
    descripcion: "",
    id_estante: "",
    id_fila: "",
  });
  const [isModalFilaOpen, setIsModalFilaOpen] = useState(false);
  const [idFilaSeleccionada, setIdFilaSeleccionada] = useState(null);
  
  const [modalDepositoOpen, setModalDepositoOpen] = useState(false);
  const [modalEstanteOpen, setModalEstanteOpen] = useState(false);
  const [modalFilaOpen, setModalFilaOpen] = useState(false);

  const [idDepositoSeleccionado, setIdDepositoSeleccionado] = useState(null);
  const [depositoSeleccionado, setDepositoSeleccionado] = useState(null);
  const [idEstanteSeleccionado, setIdEstanteSeleccionado] = useState(null);
  const [estanteSeleccionado, setEstanteSeleccionado] = useState(null);
  const [idFilaSeleccionado, setIdFilaSeleccionado] = useState(null);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [descripcionUbicacion, setDescripcionUbicacion] = useState(""); 



  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { id_estante, id_fila, descripcion} = values;

    const valuesToSend = {
      descripcion: descripcion.toUpperCase(),
      id_estante,
      id_fila
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await PostDatosColumna(valuesToSend);
      setRegistrationSuccess(true);
      toast.success("Registrado exitosamente", {
      position: "top-center", // o "bottom-center"
});

      resetForm();
      setIdDepositoSeleccionado(null);
      setDepositoSeleccionado(null);
      setIdEstanteSeleccionado(null);
      setEstanteSeleccionado(null);
      setIdFilaSeleccionado(null);
      setFilaSeleccionada(null);
      setDescripcionUbicacion("");
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setError(error.message);
      toast.error("Ocurrió un error al registrar",  {
          position: "top-center", // o "bottom-center"
        });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleSelectEstante = (estante) => {
    setSelected(estante);
    
    };


  return (
    <Box m="20px">
      <Header title="Registro Columna" subtitle="Registro Columna" />

      {isLoading && <ModalCharge />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          descripcion: "",
          id_estante: "",
          id_fila: "",
          
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Descripcion"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.descripcion || ""}
                  name="descripcion"
                  error={!!touched.descripcion && !!errors.descripcion}
                  helperText={touched.descripcion && errors.descripcion}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Ubicación"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={descripcionUbicacion}
                  name="id_fila"
                  error={!!touched.id_fila && !!errors.id_fila}
                  helperText={touched.id_fila && errors.id_fila}
                  sx={{ gridColumn: "span 2" }}

                onClick={() => {
                  setIdDepositoSeleccionado(null);
                  setDepositoSeleccionado(null);
                  setIdEstanteSeleccionado(null);
                  setEstanteSeleccionado(null);
                  setIdFilaSeleccionado(null);
                  setFilaSeleccionada(null);
                  setDescripcionUbicacion("");
                  setModalDepositoOpen(true);
                 }}
                />             
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#bac609" },
                  }}
                >
                  Guardar
                </Button>
              </Box>
            </form>
            <ModalCharge isLoading={isLoading} />
            <ModalDepositoAmoxarifado
              open={modalDepositoOpen}
              onClose={() => setModalDepositoOpen(false)}
              onSelect={(deposito) => {
                  setIdDepositoSeleccionado(deposito.id);
                  setDepositoSeleccionado(deposito);
                  setModalDepositoOpen(false);
                  setModalEstanteOpen(true);

              }}
            />
             <ModalEstanteGetOne
              open={modalEstanteOpen}
              onClose={() => setModalEstanteOpen(false)}
              idDeposito={idDepositoSeleccionado}
              nombreDeposito={depositoSeleccionado?.deposito}
              onSelect={(estante) => {
                setIdEstanteSeleccionado(estante.id);
                setEstanteSeleccionado(estante);
                setModalEstanteOpen(false);
                setModalFilaOpen(true);
                setFieldValue("id_estante", estante.id);

              }}
            />
            <ModalFilaGetOne
              open={modalFilaOpen}
              onClose={() => setModalFilaOpen(false)}
              idEstante={idEstanteSeleccionado}
              nombreEstante={estanteSeleccionado?.descripcion}
              onSelect={(fila) => {
                setIdFilaSeleccionado(fila.id);
                setFilaSeleccionada(fila);
                setModalFilaOpen(false);
                setDescripcionUbicacion(
                  `${depositoSeleccionado?.deposito}, ${estanteSeleccionado?.descripcion}, ${fila.descripcion}`
                );
                // Si estás usando Formik y querés guardar el ID real:
                setFieldValue("id_fila", fila.id);
              }}
            />

          </>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  descripcion: yup.string().required("Descripcion requerida"),
  id_estante: yup.number().required("Id_ESTANTE requerida"),
  id_fila: yup.number().required("Este campo es requerido"),


});

export default Columna;
